import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => createStyles({
  actions: {
    padding: "24px 24px",
    display: 'flex',
    flexDirection: 'row',
    width: "50%",
    justifyContent: "space-between"
  },
  btnPagination: {
    fontSize: '12px',
    lineHeight: '18px',
    padding: theme.spacing(1),
    margin: theme.spacing(0, 1),
  },
}));
